import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// utils
import { formatEchannelResponse, prepareEchannelPayload } from '../../../utils';
import { Translations } from '../../../utils/';
// constant
import { FORM_REFS, CASE_CANCELLED, CASE_COMPLETED } from '../../../constants';
// restClient
import { eapiClient, aemHostClient } from '../../../restClient';
// children
import Dynamicform from '../../common/Dynamicform/dynamicForm';
//action Creator
import { hideActionButton } from '../../layouts/actions/actionCreator';
import { updateCase } from '../actions/actionCreator';

const CreateNewEchannel = (props) => {
  const [existingEntityData, setExistingEntityData] = useState([]);
  const [formJson, setFormJson] = useState();
  const [formData, setFormData] = useState();

  const translations = (text) => {
    return Translations(text, props.lang.currentLang.lang, props.lang.translatedData)
  }

  useEffect(() => {
    let apiURL = "/aemData/formData/json_add-echannel";
    if (props.mode === "edit") {
      apiURL = apiURL.replace("add-", "edit-");
    }
    (async () => {
      const { data } = await aemHostClient(apiURL);
      setFormJson(data)
    })();


    let _caseId = Object.keys(props.cases)[0]
    let _url = "/entities/existing-organisations/" + _caseId;
    (async () => {
      const { data } = await eapiClient(_url);
      setExistingEntityData(data.responseData)
    })();
    return () => {
      // Anything in here is fired on component unmount.
    }
  }, [])

  useEffect(() => {
    if (props.history.location.pathname.includes("/create-a-case/")) {
      props.hideCrumbs();
    }
    props.hideActionButton();
  }, []);

  const getFormData = (formData) => {
    setFormData(formData)
    // this.setState({ formData });
  }

  const onFormSubmit = (event, apiURL) => {
    var case_Id;
    for (var key in props.cases) {
      if (props.cases[key].status !== CASE_CANCELLED && props.cases[key].status !== CASE_COMPLETED) {
        case_Id = props.cases[key].id;
        break;
      }
    }
    var requestData = prepareEchannelPayload({ ...formData }, case_Id);
    // const {formData} = this.state;
    // const {newEchannel} = formData;
    // // preparing payload for Echannel
    // if(newEchannel === false) {
    //   const {other} = formData;
    //   if(!other) {
    //     requestData.profileOwner = {...formData.profileOwnerInPack};
    //     requestData.profileOwnerInPack = undefined;
    //     requestData.otherProfileOwner = undefined;
    //   }else {
    //     requestData.profileOwner = {
    //       name: formData.otherProfileOwner,
    //       value: Object.keys(props.cases)[0]
    //     }
    //     requestData.profileOwnerInPack = undefined;
    //     requestData.otherProfileOwner = undefined;
    //   }
    // }

    // const caseId = requestData.profileOwner ? (requestData.profileOwner.value) : undefined;
    // requestData.caseId = caseId;

    if (props.mode === 'edit') {
      apiURL = apiURL + "/" + formData.id;
    }

    var METHOD = props.mode === 'edit' ? 'PUT' : 'POST';
    (async () => {
      const { data } = await eapiClient(apiURL, {
        method: METHOD,
        data: JSON.stringify(requestData)
      });
      const { caseId } = data.responseData;
      props.updateCase(caseId, 'echannels', data.responseData);
      props.history.goBack();
    })();

  }

  const onFormCancel = () => {
    props.history.goBack();
  }

  const renderFormGroups = () => {
    let formData;
    if (props.currentEchannel !== undefined) {
      // formatting echannel response to match form fields
      formData = formatEchannelResponse({ ...props.currentEchannel });
    } else {
      formData = {};
    }
    const properties = {
      echannelId: props.match.params.echannelId,
      caseId: props.match.params.caseId,
      formData,
      existingEntityData: existingEntityData,
      editType: 'add-echannel-to-case',
      pathname: props.history.location.pathname
    };
    if (formJson !== undefined && formJson.par.aemform_ !== undefined) {
      return (
        <Dynamicform mode={props.mode}
          properties={properties}
          url={FORM_REFS[formJson.par.aemform_.formRef]}
          getFormData={getFormData}
          onFormSubmit={onFormSubmit}
          onFormCancel={onFormCancel}
          lang={props.lang.currentLang.lang}
          translatedData={props.lang.translatedData}
          flag={props.lang.currentLangFlag.flag} />
      );
    }
  }

  const pageTitle = formJson ? formJson.par.page_title_mainTitle : '';
  return (
    (pageTitle !== undefined ?
      <div>
        <div className="form-container">
          <div className="form-title">
            <h2 className="form-heading">{translations(pageTitle.pageHeading)}</h2>
            <p className="form-required-desc">{translations(pageTitle.descriptionText)}</p>
          </div>
          {renderFormGroups()}
        </div>
      </div>
      : ''));

}

const mapStateToProps = (state, props) => {
  let currentEchannel = undefined;
  if (props.match.params) {
    var { caseId, echannelId } = props.match.params;
    if (caseId && echannelId && state.cases[caseId] && state.cases[caseId]['echannels'][echannelId]) {
      currentEchannel = state.cases[caseId]['echannels'][echannelId]
    }
  }
  return {
    cases: state.cases,
    lang: state.lang,
    currentEchannel,
    mode: currentEchannel !== undefined ? 'edit' : ''
  }
}

const mapDispatchToProps = dispatch => {
  return {
    hideActionButton: () => {
      dispatch(hideActionButton())
    },
    updateCase: (caseId, productType, productData) => {
      dispatch(updateCase(caseId, productType, productData))
    }
  }
}

CreateNewEchannel.propTypes = {
  cases: PropTypes.object,
  lang: PropTypes.object,
  mode: PropTypes.object,
  history: PropTypes.object
};

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewEchannel);



// WEBPACK FOOTER //
// ./src/components/createAcase/AddEchannel/CreateNewEchannel.js